import { FC, memo, useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import FourZeroFourComponent from 'src/components/FourZeroFourComponent';
import LicenseContext from 'src/contexts/LicenseContext';
import { DateModel } from 'src/models/DateModel';
import { normalizePlanningEndOn } from 'src/utils/planningDateRange.util';

import Component from './V3Timeline/Component';

const Timeline: FC = memo(() => {
  const { startOn, endOn } = useParams();
  const navigate = useNavigate();
  const context = useContext(LicenseContext);

  const start = new Date(startOn);
  const end = new Date(endOn);
  const [unit, setUnit] = useState<string | undefined>(undefined);
  const [customInputFields, setCustomInputFields] = useState<string[]>([]);

  const { endOn: normalizedEndOn, changed: needsUrlNormalize } = normalizePlanningEndOn(startOn ?? '', endOn);

  useEffect(() => {
    if (!context.config?.on) return;
    if (!context.config?.unit) return;

    setUnit(context.config.unit);
    setCustomInputFields(context.config.custom_input_fields);
    if (startOn) {
      // 正規化不要（= URL が既に妥当）なら navigate しない。V3Plans と揃える。
      if (!needsUrlNormalize) return;

      const paramsOnModel = new DateModel(startOn);
      if (paramsOnModel.isValid()) {
        void navigate(`/timeline/${paramsOnModel.toString()}/${normalizedEndOn}`);
        return;
      }
    }

    const configOnModel = new DateModel(context.config.on);

    if (configOnModel.isValid()) {
        void navigate(`/timeline/${configOnModel.toString()}/${configOnModel.toString()}`);
      return;
    }

    void navigate('/404');
  }, [startOn, endOn, context.config, navigate, needsUrlNormalize, normalizedEndOn]);

  if (!startOn) return <FourZeroFourComponent />;
  // 正規化前の不正なレンジ（終了日 < 開始日 など）を Component へ渡すと FullCalendar が
  // 描画時に落ちて画面が白くなる。navigate は useEffect（レンダー後）で走るため、
  // ここで描画を止めて URL が貼り替わるのを待つ。
  if (needsUrlNormalize) return null;

  return <Component startDate={start} endDate={end} unit={unit} customInputFields={customInputFields} />;
});

export default Timeline;
